export default "__VITE_ASSET__e6554451__"